import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link } from "react-router-dom";

export default function AllDiscount() {
  return (
    <>
      <Sidebar openItem="manage-discount" activeItem="all-type-discount" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">نوع تخفیف</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid" id="type-all-campaigns">
                <div className="row">
                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-banner.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>
                            تخفیف به کمپین بنری
                          </b>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center pt-3   ">
                          <Link
                            to="/manage/discount/campaign-banner/all"
                            className="btn btn-primary"
                          >
                            انتخاب
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0  campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-native.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>تخفیف به کمپین همسان</b>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3   ">
                          {/* <span className="btn btn-secondary">به زودی</span> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-push.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>تخفیف به کمپین پوش</b>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3  ">
                          {/* <span className="btn btn-secondary">به زودی</span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
